<template>
  <Card :thumbnail="$path('image.url', value)" class="shop-set-card" theme="border">
    <template #default>
      <div class="shop-set-card__title">{{ value.name }}</div>
      <ReadMore
        v-if="value.description"
        class="shop-set-card__description"
        :value="value.description"
        :limit="3"
      />

      <div class="shop-set-card__products">
        <ProductCard
          v-for="(product, index) in products"
          :key="index"
          :value="{ ...product, quantity: { enabled: false } }"
          :currency="shop.metadata.currency"
          @click="bus.$emit('product', { type: 'set', data: product })"
        />
      </div>
    </template>
    <template #footer>
      <div class="shop-set-card__total">{{ total }}</div>
      <ButtonComponent
        :label="$t('select')"
        theme="primary"
        icon="fa-pro-light:angle-right"
        @click="
          $emit(
            'select',
            products.map(p => p.id),
          )
        "
      />
    </template>
  </Card>
</template>

<script>
import { Currency } from '../utils'

import Card from '@kvass/card'
import ProductCard from '../Product/Card'
import ReadMore from '../components/ReadMore.vue'

export default {
  inject: ['bus'],
  provide: {
    getItemStatus: null,
  },
  props: {
    value: Object,
    shop: Object,
    setsStats: Object,
  },
  computed: {
    total() {
      return Currency(
        this.products.reduce((res, cur) => {
          if (cur.isDefault) return res
          return res + cur.product.gross * (cur.quantity.enabled ? cur.quantity.value : 1)
        }, 0),
        { currency: this.shop.metadata.currency },
      )
    },
    products() {
      return this.shop.categories.reduce((productLinks, category) => {
        category.categories.forEach(subcategory => {
          subcategory.items
            .filter(i => (i.sets || []).includes(this.value.id))
            .forEach(link => productLinks.push(link))
        })

        return productLinks
      }, [])
    },
  },
  components: {
    Card,
    ProductCard,
    ReadMore,
  },
}
</script>

<style lang="scss">
.shop-set-card {
  --kvass-card-spacing: 1.75rem;

  border-radius: calc(var(--border-radius) * 2);
  overflow: clip;

  .kvass-card__content {
    padding-bottom: 0;
  }

  .kvass-card__footer-content {
    justify-content: space-between;
  }

  &__description,
  &__products {
    position: relative;

    &-wrapper {
      max-height: 200px;
      overflow-y: auto;
    }
  }

  &__description {
    margin-top: 0.5rem;
    line-height: 1.42;

    &-wrapper {
      &--empty {
        opacity: 0.5;
      }

      & > span > *:first-child {
        margin-top: 0;

        p:first-child {
          margin-top: 0;
        }
      }
    }
  }

  &__products {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    padding-block: var(--kvass-card-spacing);

    overflow-y: auto;
    max-height: 300px;

    mask-image: linear-gradient(
      to bottom,
      transparent 0%,
      transparent calc(0% + 0.5rem),
      black calc(0% + var(--kvass-card-spacing)),
      black calc(100% - var(--kvass-card-spacing)),
      transparent 100%
    );

    .shop-product-card {
      width: auto;
    }
  }

  &__title {
    font-size: 1.5rem;

    margin: 0;
  }

  &__total {
    font-weight: bold;
    font-size: 1.2rem;
  }
}
</style>
